import { render } from "./AlarmCheckPermissionPropsCmp.vue?vue&type=template&id=352a898f"
import script from "./AlarmCheckPermissionPropsCmp.vue?vue&type=script&lang=js"
export * from "./AlarmCheckPermissionPropsCmp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__